import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";

export default function PageNotFound() {
  const navigate = useNavigate();

  useEffect(() => {
    // Optional: Auto-redirect after 5 seconds
    const timer = setTimeout(() => {
      navigate("/");
    }, 10000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div
      className="page-content"
      style={{
        paddingBottom: "env(safe-area-inset-bottom)",
        backgroundColor: "#000",
        minHeight: "100vh",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Header />
      {/* Header */}

      {/* Content */}
      <div
        style={{
          paddingTop: "85px",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          padding: "20px",
        }}
      >
        <div
          style={{
            fontSize: "clamp(48px, 20vw, 120px)",
            fontWeight: "bold",
            color: "#fff",
            marginBottom: "20px",
            opacity: 0.8,
          }}
        >
          404
        </div>
        <br/>
        <h2
          style={{
            fontSize: "clamp(18px, 4vw, 24px)",
            marginBottom: "10px",
            color: "#fff",
          }}
        >
          Oops! Page Not Found
        </h2>
        <p
          style={{
            fontSize: "16px",
            marginBottom: "30px",
            color: "#ccc",
            maxWidth: "400px",
            lineHeight: 1.5,
          }}
        >
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link
          to="/"
          style={{
            background: "#00000096",
            color: "#fff",
            padding: "12px 24px",
            border: "0.5px solid #fff",
            borderRadius: "15px",
            textDecoration: "none",
            fontSize: "16px",
            transition: "background 0.3s",
          }}
          onMouseEnter={(e) => (e.target.style.background = "#333")}
          onMouseLeave={(e) => (e.target.style.background = "#00000096")}
        >
          Go Home
        </Link>
      </div>
    </div>
  );
}